// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3YkWX","errorLogs":"styles_errorLogs__1otGF"};